import React, { useState } from 'react';
import './Sidebar.css';

type NodeItem = {
    type: string;
    icon: string;
    label: string;
  };

  const nodeList: NodeItem[] = [
    // System Nodes
    { type: 'StartNode', icon: '🟢', label: 'Start' },
    { type: 'ConditionNode', icon: '🔀', label: 'Condition / If-Else' },
    { type: 'LoopNode', icon: '🔁', label: 'Loop / For Each' },
    { type: 'DelayNode', icon: '⏱️', label: 'Wait / Delay' },
    { type: 'WebhookTrigger', icon: '🌐', label: 'Webhook Trigger' },
    { type: 'ManualApproval', icon: '🧍‍♂️', label: 'Human Approval' },
  
    // AI/LLM Nodes
    { type: 'LLMQuery_GPT4', icon: '🤖', label: 'LLM: GPT-4' },
    { type: 'LLMQuery_Claude3', icon: '🧠', label: 'LLM: Claude 3' },
    { type: 'LLMQuery_GeminiPro', icon: '🔮', label: 'LLM: Gemini Pro' },
    { type: 'LLMQuery_Mixtral', icon: '🌪️', label: 'LLM: Mixtral' },
    { type: 'LLMQuery_LLaMA3', icon: '🐪', label: 'LLM: LLaMA 3' },
    { type: 'LLMQuery_DeepSeek', icon: '🛰️', label: 'LLM: DeepSeek' },
    { type: 'LLMQuery_CommandR', icon: '🧬', label: 'LLM: Command R' },
    { type: 'LLMQuery_AzureGPT', icon: '☁️', label: 'LLM: Azure GPT' }
    ,
       // Banking & Finance Agents
    { type: 'AI_Compliance_Advisor', icon: '📜', label: 'AI Compliance Advisor' },
    { type: 'Fraud_Detection_Agent', icon: '🚨', label: 'Fraud Detection Agent' },
    { type: 'KYC_Document_Scanner', icon: '📑', label: 'KYC Document Scanner' },
    { type: 'Loan_Default_Predictor', icon: '📉', label: 'Loan Default Predictor' },

    // Healthcare Agents
    { type: 'HIPAA_Compliance_Agent', icon: '🩺', label: 'HIPAA Compliance Agent' },
    { type: 'Patient_Engagement_Agent', icon: '👨‍⚕️', label: 'Patient Engagement Agent' },
    { type: 'Medical_Report_Summarizer', icon: '📄', label: 'Medical Report Summarizer' },
    { type: 'Claims_Processing_Agent', icon: '💰', label: 'Claims Processing Agent' },

    // Retail & eCommerce Agents
    { type: 'Churn_Prediction_Agent', icon: '🔁', label: 'Churn Prediction Agent' },
    { type: 'Dynamic_Discount_Advisor', icon: '💸', label: 'Dynamic Discount Advisor' },
    { type: 'Sentiment_Review_Analyzer', icon: '💬', label: 'Sentiment Review Analyzer' },
    { type: 'Cart_Recovery_Agent', icon: '🛒', label: 'Cart Recovery Agent' },

    // Manufacturing & Supply Chain Agents
    { type: 'Supplier_Risk_Scorer', icon: '📦', label: 'Supplier Risk Scorer' },
    { type: 'Predictive_Procurement_Agent', icon: '📈', label: 'Predictive Procurement Agent' },
    { type: 'Quality_Control_Analyzer', icon: '🔍', label: 'Quality Control Analyzer' },

    // Sales & Marketing Agents
    { type: 'Lead_Scoring_Agent', icon: '📊', label: 'Lead Scoring Agent' },
    { type: 'Content_Generator_Agent', icon: '✍️', label: 'Content Generator Agent' },
    { type: 'Campaign_Optimizer_Agent', icon: '🎯', label: 'Campaign Optimizer Agent' },
    { type: 'Customer_Sentiment_Agent', icon: '📢', label: 'Customer Sentiment Agent' },
    // Communication
    { type: 'SendEmail', icon: '✉️', label: 'Send Email' },
    { type: 'SendSMS', icon: '📱', label: 'Send SMS' },
    { type: 'SendSlack', icon: '💬', label: 'Post to Slack / Teams' },
    { type: 'ChatReply', icon: '🤖', label: 'Chat Agent Reply' },
  
    // HR Domain
    { type: 'LeaveRequest', icon: '🗓️', label: 'Submit Leave Request' },
    { type: 'InterviewSchedule', icon: '📅', label: 'Schedule Interview' },
    { type: 'OnboardingChecklist', icon: '✅', label: 'HR Onboarding' },
  
    // Sales & CRM
    { type: 'LeadCapture', icon: '📥', label: 'Capture Lead' },
    { type: 'CRMUpdate', icon: '🔄', label: 'Update CRM Record' },
    { type: 'DealScore', icon: '📊', label: 'Score Deal Opportunity' },
    { type: 'ProposalGenerator', icon: '🧾', label: 'Generate Proposal' },
  
    // Support & IT
    { type: 'CreateTicket', icon: '🎫', label: 'Create Support Ticket' },
    { type: 'ClassifyIssue', icon: '🔍', label: 'Classify Issue' },
    { type: 'EscalateTicket', icon: '🚨', label: 'Escalate to Tier 2' },
  
    // Finance
    { type: 'InvoiceGenerator', icon: '📄', label: 'Generate Invoice' },
    { type: 'PaymentReminder', icon: '💳', label: 'Send Payment Reminder' },
    { type: 'BudgetApproval', icon: '📈', label: 'Approve Budget' },
  
    // Logistics / Procurement
    { type: 'CheckStock', icon: '📦', label: 'Check Inventory' },
    { type: 'OrderSupplies', icon: '🛒', label: 'Order Supplies' },
    { type: 'VendorAlert', icon: '📬', label: 'Notify Vendor' },
  ];
  

const Sidebar: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState('');
  
    const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string) => {
      event.dataTransfer.setData('application/reactflow', nodeType);
      event.dataTransfer.effectAllowed = 'move';
    };
  
    const filteredNodes = nodeList.filter((node) =>
      node.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  
    return (
      <aside className="sidebar">
        <div className="sidebar-title">Controls</div>
  
        <input
          className="sidebar-search"
          type="text"
          placeholder="Search nodes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
  
        <div className="sidebar-list">
          {filteredNodes.map((node) => (
            <div
              key={node.type}
              className="sidebar-node"
              onDragStart={(event) => onDragStart(event, node.type)}
              draggable
            >
              <div className="node-icon">{node.icon}</div>
              <div className="node-label">{node.label}</div>
            </div>
          ))}
        </div>
      </aside>
    );
  };
  
  export default Sidebar;
  